<template>
  <div class="result">
    <div class="title">
      <span class="q">{{ searchInfo.question }} </span>的搜索结果:
    </div>
    <div class="content">
      <div class="items">
        <div
          class="item"
          v-for="(item, index) in searchInfo.datas"
          :key="item.uuid || index"
          :class="showIndex == index ? 'active' : ''"
        >
          <div class="question" @click="showIndex = index">
            {{ index + 1 }} :
            <div :class="'color' + (index % 5)">
              [{{ item.qtype | questionType }}]
            </div>
            {{ item.question }}
          </div>
          <transition name="breadcrumb" mode="in-out">
            <div class="more" v-if="showIndex == index">
              <div class="options">选项 : {{ item.options }}</div>
              <div class="answer">答案: {{ item.answer }}</div>
              <div class="detail">解析: {{ item.content }}</div>
            </div>
            <div class="tip" @click="showIndex = index" v-else>
              点击查看答案
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    searchInfo() {
      return this.$store.getters.getSearchInfo;
    },
  },
  data() {
    return {
      showIndex: 0,
    };
  },
  filters: {
    questionType(val) {
      switch (val) {
        case 1:
          return "单选题";
        case 2:
          return "多选题";
        case 3:
          return "填空题";
        case 4:
          return "问答题";
        case 5:
          return "判断题";
        default:
          return "其他";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  width: 1284px;
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  margin: 2rem auto;
  .title {
    span {
      font-size: 2rem;
      color: #5932ea;
    }
    font-size: 1.6rem;
  }
  .content {
    .items {
      display: flex;
      flex-direction: column;
      .item {
        cursor: default;
        border-radius: 10px;
        padding: 1rem;
        &:hover {
          background: #f7f9fe;
        }
        .question {
          * {
            display: inline-block;
          }
          .qtype {
            color: #5932ea;
          }
        }
      }
      .active {
        background: #f7f9fe;
      }
    }
  }
}
</style>
